import React from 'react';
import { createPortal } from 'react-dom';
/** Modal component for displaying anything */
export default props => {
    const close = () => props.onClose();
    return createPortal(
        <div className="Modal">
            <div className="backdrop" onClick={() => close()}></div>
            <div className="content">
                {props.children}
            </div>
        </div>,
        document.getElementById('modal-root')
    );
}